import { render, staticRenderFns } from "./ResourceDetailsList.vue?vue&type=template&id=02d19eb1"
import script from "./ResourceDetailsList.vue?vue&type=script&lang=js"
export * from "./ResourceDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports